import {RemoteRefundDeleteFile} from 'data/usecases';
import {DeleteRefundRemoveFile} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {RefundFlowEndPoints} from '../../../endpoints';

export const makeDeleteRefundUploadFile = (attachmentId: string): DeleteRefundRemoveFile =>
	new RemoteRefundDeleteFile(
		makeBFFApiUrl(`${RefundFlowEndPoints.attachment}/${attachmentId}`),
		makeAuthorizeHttpClientDecorator(),
	);
